import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { li, root } from './QA.module.scss';

const QA = ({ data }) => (
  <Section className={root}>
    <Wrapper size="MS">
      <Heading Tag="h1" bold marginBottom="S" center>常見問題</Heading>
      <ul>
        { data.map((item, i) => (
          <li key={i} className={li}>
            <P size="XL" bold marginBottom="Xxs">{item.q}</P>
            <P>{item.a}</P>
          </li>
        )) }
      </ul>
    </Wrapper>
  </Section>
);

QA.propTypes = {
  data: PropTypes.array,
}

export default QA;